import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { sharedModule } from '../shared/shared.module';
import { MaterialModule } from '../../material/material.module';
import { PublicPagesRoutes } from './public-pages.routes'
import { PublicPagesComponent } from './public-pages.component';
import { LogInComponent } from './log-in/log-in.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
      PublicPagesComponent,
      LogInComponent,
    ],
    exports: [],
    imports: [
      CommonModule,
      MaterialModule,
      sharedModule,
      PublicPagesRoutes,
      ReactiveFormsModule
    ]
  })

export class PublicPagesModule {
}
